import { render, staticRenderFns } from "./u-btn-icon-flat-tile.vue?vue&type=template&id=42e1ec88&scoped=true"
import script from "./u-btn-icon-flat-tile.vue?vue&type=script&lang=js"
export * from "./u-btn-icon-flat-tile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e1ec88",
  null
  
)

export default component.exports